import React from 'react'
import ProfileItemForm from "./ProfileItemForm";

export default class ProfileLinkForm extends ProfileItemForm {

    static ItemType = 'Link'

    static FormClass = 'talent-role-form add-talent-form add-link-form '

    static TypeConfig = {
        icon: 'fa fa-link',
        color: TB.config('color.blue')
    }

    constructor(props) {
        super(props);

        this.formRef = React.createRef();
        this.state = {
            model: {
                url: 'https://',
                ...this.getModelFromProps(),
            }
        }
    }


    /**
     * The fields mapping for the form
     */
    formFields = () => {

        let linkOptions = TB.mapValues(
            laravel.talent_profile_link_types,
            'name'
        );

        return [
            {
                style: styles.fieldSection,
                fields: {
                    type: {
                        type: 'select',
                        options: linkOptions,
                        required: true,
                        label: TB.trans('talent.profile_link_form.type_label'),
                        placeholder: TB.trans('talent.profile_link_form.type_placeholder'),
                        style: styles.field,
                        columns: 8
                    }
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    url: {
                        type: 'url',
                        placeholder: TB.trans('talent.profile_link_form.url_placeholder'),
                        maxLength: 255,
                        required: true,
                        label: TB.trans('talent.profile_link_form.url_label'),
                        style: styles.field,
                        autoComplete: 'off',
                        columns: 8
                    }
                }
            }
        ]
    };

}

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};
